import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LoadingReportResponse } from './loading-report-response.dto';

export class ContainerLoadingReportResponseModel extends GlobalResponseObject{
    data?: LoadingReportResponse;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data ContainerLogBookDTO
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: LoadingReportResponse) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}